
export default function initFavorites(){
	const storageKey = 'mefa-favorites';
	const favorites = JSON.parse(localStorage.getItem(storageKey)) || [];

	const updateFavorites = () => {
		localStorage.setItem(storageKey, JSON.stringify(favorites));

		const event = new CustomEvent('localStorageChange', { detail: { storageKey, favorites } });
		window.dispatchEvent(event);
	};

	const addFavorite = (id) => {
		if(!favorites.includes(id)){
			favorites.push(id);
			updateFavorites();
		}
	};

	const removeFavorite = (id) => {
		const index = favorites.indexOf(id);
		if (index > -1) {
			favorites.splice(index, 1);
			updateFavorites();
		}
	};

	const setupFavoriteEl = (el) => {
		if(!el._favoriteHandlerSet){
			el._favoriteHandlerSet = true;
			el.addEventListener('click', (e) => {
				e.preventDefault();
				if(el.classList.contains('is-favorite')){
					removeFavorite(el.dataset.id);
				}else{
					addFavorite(el.dataset.id);
				}

				el.classList.toggle('is-favorite');
			});
		}
	};

	document.querySelectorAll('.js-favorite-btn').forEach(el => {
		if(favorites.includes(el.dataset.id)){
			el.classList.add('is-favorite');
		}
		setupFavoriteEl(el);
	});

	new MutationObserver(() => {
		document.querySelectorAll('.js-favorite-btn').forEach(el => {
			if(favorites.includes(el.dataset.id)){
				el.classList.add('is-favorite');
			}
			setupFavoriteEl(el);
		});
	}).observe(document.body, {
		childList: true,
		subtree: true
	});
}
